import { createEntityAdapter, EntityState } from '@ngrx/entity';

interface UserSessionInfo {
  userId: number;
  isAllowIndividualRecording: boolean;
  isManager: boolean;
  subsessionId: string;
  userIdentity: string;
  displayName: string;
  isHost: boolean;
  isPhoneUser: boolean;
  userGuid: string;
  audio: string;
  muted: boolean;
  isVideoConnect: boolean;
  bVideoOn: boolean;
}

type PartialRequired<T, K extends keyof T> = Pick<T, K> & Partial<Omit<T, K>>;

export type UserSession = PartialRequired<UserSessionInfo, 'userId'>;

export interface UserSessionsState extends EntityState<UserSession> {
  currentSessionId: string | null;
}

function selectSessionId(s: UserSession): number {
  return s.userId;
}

function sortByFields(s1: UserSession, s2: UserSession) {
  if (!!s1.bVideoOn && !s2.bVideoOn) {
    return 1;
  }
  return 0;
}

export const userSessionsAdapter = createEntityAdapter<UserSession>({
  selectId: selectSessionId,
  sortComparer: sortByFields,
});
